import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { authLogout, authLogoutSuccess } from './core/actions';
import { getAuthTokenSelector, getErrorSelector, getPendingSelector } from './core/selectors';
import { Loading } from '@components/index';
import * as API from '@api/types';

export function Logout() {
  const dispatch = useDispatch();
  const accessToken = useSelector(getAuthTokenSelector);
  const pending = useSelector(getPendingSelector);
  const error = useSelector(getErrorSelector);

  useEffect(() => {
    if (accessToken) dispatch(authLogout({ accessToken }));
  }, [dispatch, accessToken]);

  // If the logout API call failed (network error, expired token, etc.),
  // force-clear auth state so the user isn't stuck on a loading screen.
  useEffect(() => {
    if (error && !pending) {
      localStorage.removeItem('auth.sessionToken');
      localStorage.removeItem('auth.sessionTokenTimestamp');
      dispatch(authLogoutSuccess({} as API.AuthLogoutResponse));
    }
  }, [error, pending, dispatch]);

  return accessToken || pending ? <Loading /> : <Navigate to="/auth" replace />;
}
